babble = require './babble'
pattern = require 'matchbook'
f = require 'effing'
assert = require 'lib/assert'
_ = require 'underscore'

strings = _.clone require('locale').strings

for key, value of _.pick(require('locale'), 'axis', 'exports', 'labels', 'templates', 'billing')
  assert(key !of strings)
  strings[key] = value

visitor = babble.makeVisitor f.id, (key, substitutions, options = {}) ->
  assert substitutions.hasOwnProperty(key), "'#{key}' not found in #{JSON.stringify(substitutions)}"
  value = substitutions[key]
  assert (typeof value == 'string'), "I don't know how to convert values into strings. Please use a localized conversion function and pass me the string result."
  if options.raw
    value
  else
    _.escape value

visit = f(babble.visit, strings)

module.exports = (keyPath, args = {}, options) ->
  visit(keyPath, visitor, args, options)?.join('')



// WEBPACK FOOTER //
// ./app/scripts/lib/try-babble.coffee